package app.smartcoding.realrate.platform

import app.smartcoding.realrate.domain.model.AuthUser
import app.smartcoding.realrate.domain.model.SettingsState
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore

actual suspend fun saveUserSettings(
    authUser: AuthUser.User,
    settings: SettingsState,
    onSuccess: () -> Unit,
    onFailed: (Throwable) -> Unit
) {
    try {
        Firebase
            .firestore
            .collection("user-settings")
            .document(authUser.uid)
            .set(settings)
        onSuccess()
    } catch (e: Exception) {
        onFailed(e)
    }
}